import { useApp } from "@/context/AppContext";
import { LEAVE_KINDS, KIND_TONE, leaveStats, today, onLeave } from "@/lib/hr";
import HrEventForm from "./HrEventForm";
import HrEventList from "./HrEventList";

const Stat = ({ label, v, max, tone, testid }) => (
  <div className="rounded border border-[#CCCCCC] bg-white p-2.5">
    <div className="text-[11px] text-[#666]">{label}</div>
    <div className="text-xl font-extrabold" style={{ color: tone }} data-testid={testid}>{v}{max != null && <span className="text-sm font-normal text-[#888]"> / {max}</span>}</div>
  </div>
);

function MonthCalendar({ events, month }) {
  const [y, m] = month.split("-").map(Number);
  const days = new Date(y, m, 0).getDate();
  const first = new Date(y, m - 1, 1).getDay();
  return (
    <div className="grid grid-cols-7 gap-1 text-center text-xs" dir="ltr" data-testid="hr-calendar">
      {Array.from({ length: first }).map((_, i) => <span key={`e${i}`} />)}
      {Array.from({ length: days }).map((_, i) => {
        const d = `${month}-${String(i + 1).padStart(2, "0")}`;
        const ev = onLeave(events, d);
        return <span key={d} title={ev ? ev.kind : ""} className={`h-8 rounded grid place-items-center font-bold ${ev ? "text-white" : "bg-[#F0F0F0] text-[#555]"} ${d === today() ? "ring-2 ring-[#2B79C2]" : ""}`} style={ev ? { background: KIND_TONE[ev.kind] } : undefined}>{i + 1}</span>;
      })}
    </div>
  );
}

export default function Leave({ member, events }) {
  const { t, can } = useApp();
  const month = today().slice(0, 7);
  const st = leaveStats(events, month);
  const leaves = events.filter((e) => LEAVE_KINDS.includes(e.kind));
  return (
    <div className="space-y-4" data-testid="hr-leave">
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-2">
        <Stat label={`${t("hr_used_days_off")} · ${t("hr_month")}`} v={st.dayOffM} max={member.days_off_month ?? 4} tone="#2B79C2" testid="hr-stat-dayoff" />
        <Stat label={`${t("hr_sick_days")} · ${t("hr_year")}`} v={st.sickY} tone="#B86E1F" testid="hr-stat-sick" />
        <Stat label={`${t("hr_vacation_days")} · ${t("hr_year")}`} v={st.vacY} tone="#1F9D55" />
        <Stat label={`${t("hr_absences")} · ${t("hr_month")}`} v={st.absM} tone="#C7353B" testid="hr-stat-absence" />
        <Stat label={`${t("hr_kind_late")} · ${t("hr_month")}`} v={st.lateM} tone="#E67E22" />
      </div>
      <div className="grid lg:grid-cols-[1fr_300px] gap-4">
        <div>
          {can("team") && <HrEventForm member={member} mode="leave" />}
          <div className="mt-3"><HrEventList events={leaves} member={member} /></div>
        </div>
        <div className="rounded border border-[#CCCCCC] bg-white p-3">
          <div className="text-sm font-bold mb-2">{t("hr_calendar")} · <span dir="ltr">{month}</span></div>
          <MonthCalendar events={leaves} month={month} />
        </div>
      </div>
    </div>
  );
}
